export default __webpack_public_path__ + "static/media/CEM-Title-Image.67f557ea.jpeg";